
import Vue from 'vue'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

import Pedidos from '@/components/Pedidos.vue'
import PreCadastro from '@/components/PreCadastro.vue'
import CarrinhoFooter from '@/components/CarrinhoFooter.vue'

export default Vue.extend({
  components: { Pedidos, PreCadastro, CarrinhoFooter },
  name: 'App',
  data: () => ({
    drawer: false,
    items: [
      {
        action: 'mdi-ticket',
        title: 'Início',
        to: '/'
      }, 
      {
        action: 'mdi-ticket',
        title: 'Meus Pedidos',
        to: '/login/visitante'
      }, 
      {
        action: 'mdi-ticket',
        title: 'Área do Sócio',
        to: '/login/socio'
      }, 
      // {
      //   action: 'mdi-ticket',
      //   title: 'Parque Farroupilha',
      //   items: [{
      //     title: 'Sobre o Parque',
      //     to: '/sobre/farroupilha'
      //   }, {
      //     title: 'Thermas Clube',
      //     to: '/thermas'
      //   }, {
      //     title: 'Excursões',
      //     to: '/excursoes/farroupilha'
      //   }, {
      //     title: 'Associe-se',
      //     to: '/associe-se/farroupilha'
      //   }, {
      //     title: 'Contato',
      //     to: '/contato/farroupilha'
      //   }]
      // }, 
      // {
      //   action: 'mdi-silverware-fork-knife',
      //   title: 'Parque Viamão',
      //   items: [{
      //     title: 'Sobre o Parque',
      //     to: '/sobre/viamao'
      //   }, /* {
      //     title: 'Jeito Campeiro',
      //     to: '/jeito-campeiro'
      //   }, */{
      //     title: 'Excursões',
      //     to: '/excursoes/viamao'
      //   }, {
      //     title: 'Associe-se',
      //     to: '/associe-se/viamao'
      //   }, {
      //     title: 'Contato',
      //     to: '/contato/viamao'
      //   }]
      // },
      // {
      //   action: 'mdi-ticket',
      //   title: 'COMPRE AQUI',
      //   to: '/selecione/parque'
      // }
    ]
  }),
  computed: {
    ...mapState(['carrinho', 'erroAjax', 'mensagemErro', 'dialogErro']),
    ...mapGetters(['totalIngressos', 'totalCarrinho'])
  },
  created () {
    this.getDados()
  },
  methods: {
    ...mapActions(['getDados', 'goToPagamento']),
    ...mapMutations(['toggleDialogLogin', 'dialogLogin']),
    abreFace () {
      window.open('https://www.facebook.com/clubeparquedasaguasfarroupilha')
    },
    abreInstaFarroupilha () {
      window.open('https://instagram.com/thermas_clube_parque_daguas')
    },
    abreInstaViamao () {
      window.open('https://www.instagram.com/clubeparquedasaguasviamao/')
    },
    abreYoutube () {
      window.open('https://www.youtube.com/channel/UCZlO2pcW0vVcH41YoeMNoaw')
    }
  }
})
